export default "__VITE_ASSET__$doNqbHU__"